if (!customElements.get('rnf-story-panel')) {
  customElements.define('rnf-story-panel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const toggle = this.querySelector('.rnf-story-panel__toggle');
      const content = this.querySelector('.rnf-story-panel__content');
      if (!toggle || !content) return;

      this.controller = new AbortController();
      const { signal } = this.controller;
      const mouseHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      let pinned = this.hasAttribute('data-open-initially');
      let hovered = false;
      let suppressed = false;
      let reading = false;

      const render = () => {
        const expanded = pinned || reading || (hovered && !suppressed);
        this.dataset.open = String(expanded);
        toggle.setAttribute('aria-expanded', String(expanded));
        content.inert = !expanded;
        content.setAttribute('aria-hidden', String(!expanded));
      };

      toggle.addEventListener('pointerenter', (event) => {
        if (!mouseHover.matches || event.pointerType === 'touch') return;
        hovered = true;
        suppressed = false;
        render();
      }, { signal });

      this.addEventListener('pointerleave', () => {
        hovered = false;
        suppressed = false;
        render();
      }, { signal });

      toggle.addEventListener('click', () => {
        pinned = !pinned;
        suppressed = !pinned;
        if (!pinned) {
          reading = false;
          if (content.contains(document.activeElement)) toggle.focus({ preventScroll: true });
        }
        render();
      }, { signal });

      content.addEventListener('focusin', () => {
        reading = true;
        render();
      }, { signal });

      content.addEventListener('focusout', (event) => {
        if (content.contains(event.relatedTarget)) return;
        reading = false;
        render();
      }, { signal });

      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || this.dataset.open !== 'true') return;
        event.preventDefault();
        event.stopPropagation();
        pinned = false;
        hovered = false;
        suppressed = true;
        reading = false;
        render();
        toggle.focus({ preventScroll: true });
      }, { signal });

      mouseHover.addEventListener('change', () => {
        hovered = false;
        suppressed = false;
        render();
      }, { signal });

      render();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
